import React from 'react';
import './password.css';
import CIR1 from './images/CIR1.png';
import White from './images/white.png';
import looogo from './images/CompanyLogo.svg';
import {Link} from 'react-router-dom';

function ForgotPassword() {
  return (
    <div className="forgot-password-container">
        <Link to="/">
        <img src={looogo} className="looogo" alt="Logo" />
      </Link>
      <div className="left">
    
        <h1>No Worries.!!</h1>
        <div className="dotted-line"></div>
      </div>
      <div className="right">
        <div className="blur-background"></div>
        <form className="forgot-password-form">
          <h2>Forgot Password ?</h2>
          <p>Please enter your email</p>
          <input type="email" placeholder="example@mail.com" required />
          <button type="submit" className="reset-button">Reset Password</button>
          <p>
            Don’t have an account ? <a href="/signup">Signup</a>
          </p>
          <div className="footer-links">
            <a href="/terms">Terms & Conditions</a>
            <a href="/support">Support</a>
            <a href="/customer-care">Customer Care</a>
          </div>
        </form>
      </div>
      <img src={CIR1} className="circle ppurple"></img>
      <div className="circle wwhite"></div>
      <div className="circle ppu"></div>
      <div className="circle whh"></div>
      <div className="circle puur"></div>
      <div className="circle purrr"></div>
    </div>
  );
}

export default ForgotPassword;
